import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import { Link } from '~/components'
import ROUTES from '~/shared/constants/routes.const'
import { Breakpoint, useCheckBreakpoint } from '~/utils'
import { menus } from '~/donation/constants/menu.const'
import DonateLink from '~/donation/components/DonateLink'

function MenuBar(): React.ReactElement {
  const router = useRouter()
  const { t } = useTranslation('donation')
  const isSmallScreen = useCheckBreakpoint({ lt: Breakpoint.MD })

  return (
    <div
      className={`mx-auto max-w-150 flex items-center text-white tracking-widest text-sm ${
        isSmallScreen ? 'justify-center' : 'justify-between px-3'
      }`}
    >
      {!isSmallScreen &&
        menus.map((menu) => {
          return (
            <Link className="py-2 px-3 flex flex-col items-center" key={menu.titleKey} to={menu.path}>
              {t(`menu.${menu.titleKey}`)}
              {router.asPath === menu.path && <hr className="w-5/6 border border-yellow-golden rounded" />}
            </Link>
          )
        })}
      <DonateLink
        className={router.asPath === ROUTES.MATHMAGIC || !isSmallScreen ? 'text-blue-strong font-bold' : 'invisible'}
      />
    </div>
  )
}

export default MenuBar
